/**
 * index.tsx
 * 
 * 职责：
 * 1. 应用程序的实际入口点
 * 2. 将React应用挂载到DOM节点上
 * 3. 配置React严格模式
 * 4. 初始化性能监控(reportWebVitals)
 * 5. 导入全局样式和主要组件
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import DrawingApp from './components/DrawingApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <DrawingApp />
  </React.StrictMode>
);

// 性能监控组件已移除

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((metric) => {
  // 如果有分析服务，可以将数据发送到该服务
  // sendToAnalyticsService(metric);
});
